import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@mui/styles";
import { Divider, List, ListItem } from "@mui/material";
import NavLink from "./NavLink";

const useStyles = makeStyles((theme) => ({
  root: {},
  listItem: {
    flexDirection: "column",
    alignItems: "flex-start",
    fontSize: theme.typography.h5.fontSize,
  },
  listItemText: {
    flex: "0 0 auto",
    whiteSpace: "nowrap",
    textDecoration: "none",
    fontSize: theme.typography.h5.fontSize,
  },
  listItemIcon: {
    minWidth: "auto",
  },
  listItemLink: {
    textDecoration: "none",
  },
  closeIcon: {
    justifyContent: "flex-end",
    cursor: "pointer",
  },
  activeLink: {
    fontWeight: "bold",
    color: theme.palette.primary.light,
    whiteSpace: "nowrap",
    "&:hover": {
      background: "transparent",
      textDecoration: "none",
      color: theme.palette.primary.light,
    },
  },
  inActiveLink: {
    color: theme.palette.grey[700],
    whiteSpace: "nowrap",
    "&:hover": {
      background: "transparent",
      textDecoration: "none",
      color: theme.palette.grey[700],
    },
  },
  divider: {
    width: "100%",
  },
  logoContainer: {
    width: 120,
  },
  logoImage: {
    width: "100%",
    height: "100%",
  },
  logoItem: {
    flex: "0 0 auto",
    whiteSpace: "nowrap",
    padding: theme.spacing(0, 2),
  },
}));

const SidebarNav = (props) => {
  const { onClose, className, ...rest } = props;
  let theme = useTheme();
  const classes = useStyles(theme);

  return (
    <List {...rest} className={clsx(classes.root, className)}>
      <ListItem className={classes.logoItem}>
        <div className={classes.logoContainer}>
          <a href="/" title="Home">
            <img
              className={clsx("image", classes.root, classes.logoImage)}
              alt="Finsoft-Ai"
              src="/SSI_Logo.png"
            />
          </a>
        </div>
      </ListItem>

      <Divider />

      <ListItem className={classes.listItem}>
        <NavLink
          activeClassName={classes.activeLink}
          inactiveClassName={classes.inActiveLink}
          className="text-nowrap"
          exact
          to=""
        >
          Run/Enrich
        </NavLink>
      </ListItem>
      <ListItem className={classes.listItem}>
        <NavLink
          activeClassName={classes.activeLink}
          inactiveClassName={classes.inActiveLink}
          className="text-nowrap"
          to="logs"
        >
          Logs
        </NavLink>
      </ListItem>
      <ListItem className={classes.listItem}>
        <NavLink
          activeClassName={classes.activeLink}
          inactiveClassName={classes.inActiveLink}
          className="text-nowrap"
          to="schedules"
        >
          Schedules
        </NavLink>
      </ListItem>
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
};

export default SidebarNav;
